<script setup lang="ts">
const { t } = useI18n()

defineEmits<{
  'click:openPreviewModal': []
}>()
</script>
<template>
  <div
    class="absolute top-1 md:top-2 right-1 md:right-2 z-1 flex gap-1 md:gap-2 text-xs md:text-base"
  >
    <Button
      color="tertiary"
      class="px-2 md:px-2 py-0.5 text-sm text-stone-800"
      data-test-id="see-all-images-button"
      @click.stop.prevent="$emit('click:openPreviewModal')"
    >
      {{ t('product.seeAllImages') }}
    </Button>
  </div>
</template>
